<app-account-status-item
  [status]="AccountState.Success"
  header="Account Created"
></app-account-status-item>

<app-account-status-item
  [status]="accountStatus.audience"
  header="Audience Bootstrap"
  errorMessage="Could not bootstrap account. Inviting users to the account will be disabled until bootstrap is complete"
></app-account-status-item>

<app-account-status-item
  [status]="accountStatus.adminInvite"
  header="Account owner Invited"
  errorMessage="Could not invite a user to this account. Please try again from the account details page."
></app-account-status-item>

<div class="alert alert-info" *ngIf="isBootstrapComplete">
  <i class="fas fa-check"></i> All steps are completed!
</div>
